// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionInProcess_container__dlKZ-","box":"SubscriptionInProcess_box__KYrF3","icon":"SubscriptionInProcess_icon__uhUih","pop":"SubscriptionInProcess_pop__vlwDK"};